<template>
    <div>
    <div class="container mt-4 mb-4">
        <!-- <atras-component></atras-component> -->
        <boton-atras :nombre_ruta="'estatal'"></boton-atras>
        <div class="row">
            <div class="col-md  mt-1 order-2 order-sm-2 order-md-1 order-lg-1">
                <h6 class="subtitulo mb-2">Normas</h6>
                <div class="lineaNegra"></div>
                <div class="mt-1 mb-2 lineaNegra2"></div>
                <a :href="urlServe+'marco-juridico/Estatal/informacion/Normas/Presupuestaria.pdf'" target="_blank">
                    <div class="mb-2">
                        <div class="title_document" style="display:flex; justify-content:space-between;">
                             <div class="col-8">
                                <h5>Normas Presupuestarias para la Administración Pública del Estado de Chiapas</h5>
                            </div>
                            <div class="col-3">
                                <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                            </div>
                        </div>
                    </div>
                </a>
                <a :href="urlServe+'marco-juridico/Estatal/informacion/Normas/Tarifas_2020.pdf'" target="_blank">
                    <div class="mb-2">
                        <div class="title_document" style="display:flex; justify-content:space-between;">
                            <div class="col-9">
                                <h5>Normas y Tarifas para la aplicación de Viáticos y Pasajes para el Estado de Chiapas</h5>
                            </div>
                            <div class="col-4">
                                <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                            </div>
                        </div>
                    </div>
                </a>
                <!--  -->
                <!--  -->
                <h4 class="subtitulo2 mt-5">Normatividad Contable y Financiera</h4>
               <normas-collapse></normas-collapse>

            </div>

            <div class="col-md order-1 order-sm-1 order-md-2 order-lg-2 ">
                <div class="row margenes">
                    <div class="sec_imagen">
                        <img src="@/assets/imagenes/normas.jpg" alt="">
                    </div>
                </div>
                <!--  -->
                <!--  -->
                <div class="row mt-4 row margenes tab-select">

                    <!-- <leyes-decretos-collapse></leyes-decretos-collapse>  -->
                    <!-- <normas-collapse></normas-collapse> -->

                </div>


            </div>
        </div>
    </div>
    <div class="text-aviso my-5">
        <h5> <span class="resaltado-vino">AVISO:</span> Los instrumentos jurídicos que se mencionan a continuación, son solo de referencia, encontrándose para su consulta oficial en el portal de internet de la <u><a href="https://www.sgg.chiapas.gob.mx/" target="_blank" class="resaltado-vino">Secretaría General de Gobierno</a></u>, o en su caso en la versión impresa en el órgano de difusión oficial.</h5>
    </div>

    </div>
</template>

<script>
import atrasComponent from './../../reload.vue'
import normasCollapse from './normas-collapse.vue'
import botonAtras from './../../button-atras'

export default {
    mounted(){
        window.scrollTo(0, 0);
    },
    components:{
        atrasComponent,
        normasCollapse,
        botonAtras
    }
}
</script>

<style scoped>
    .title_document {
        padding: .8rem 1rem;
        width: 100%;
        height: auto;
        border: 1px solid#dfdfdf ;
        border-radius: 5px;
        border-left: 3px solid #621132;

        display: flex;
        justify-content: space-between;
        align-items: center !important;
    }

    .title_document:hover{
        box-shadow: 3px 8px 17px -13px rgba(0,0,0,0.75) !important;
    }

    .descargar{
        font-size: 0.9rem;
        color: #6c757d !important;
    }

    .subtitulo {
        font-weight: 400;
        font-size: 1.8rem;
        margin-top: 1rem;
    }
    .subtitulo2{
        font-weight: 400;
        font-size: 1.2rem;
        margin-top: .5rem;
        margin-bottom: 1rem ;
    }
    .title_document h5{
        font-size: 0.9rem;
        font-weight: 400;
        line-height: 20px;
    }

    .sec_imagen{
        width:85% !important;
        background-color: #560F2C;
        /* margin-top: 3rem; */
    }

    a{
        text-decoration: none !important;
        color: #212529;
    }
    a:hover{ color:#212529 !important; }

    /* margenes de la card consulta */
    .margenes{
        display: flex;
        justify-content: flex-end;
    }
    .card-width{ width: 90%; }

    /* select */
    .form-control-lg {
        font-size: 1rem;
        border-radius: .4rem;
    }

    .tab-select{
        position: sticky !important;
        top: 15% !important;
        z-index: 1000 !important;
    }

@media only screen and (max-device-width : 900px) {
    .container{
        padding-right: 1% !important;
        padding-left: 1% !important;
    }
    .title_document{
        padding: .5rem 1rem .5rem .1rem;
        line-height: 20px;
    }

    /* margenes de la card consulta */
    .margenes{ justify-content: space-around; }
    .card-width{ width: 95%; }

    .subtitulo2{ font-size: 1rem; }

    .sec_imagen{ margin-top: 0rem; }


    .tab-select{
        position: initial;
        z-index: auto;
    }
}

</style>
